export function padNumber(num, places = 4) {
  if (typeof num !== "number") return num;
  return String(num).padStart(places, "0");
}
